import React from "react";
var __jsx = React.createElement;
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useTranslation } from "@i18n";
import FlowStepTitle from "@/pages/sell-my-car/components/FlowStepTitle";
import FlowOption from "@/pages/sell-my-car/components/FlowOption";
import FlowOptionBody from "@/pages/sell-my-car/components/FlowOptionBody";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import { useLang } from "@/common/Contexts/LanguageContext";
import useBoolean from "@hooks/useBoolean";
import { useEffect } from "react";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
var CarOdometerScreen = function CarOdometerScreen() {
  var _state$odometerRanges;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var loading = useBoolean(true);
  useEffect(function () {
    setTimeout(function () {
      loading.setFalse();
    }, 300);
  }, []);
  var handleOdometerSelect = function handleOdometerSelect(range) {
    actions.selectOdometer(range);
    navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_OWNERSHIP);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-odometer-screen",
    className: "p-4 flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement(FlowStepTitle, null, tShort("sell_trade_v2/choose_odometer", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement(Conditional, {
    condition: (state === null || state === void 0 ? void 0 : state.isLoading) || loading.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowOptionLoading, {
    className: "md:h-[58px]",
    length: 6,
    gridClassName: "md:grid-cols-3"
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-odometer-list",
    className: "flex flex-col gap-3 md:grid md:grid-cols-3 md:gap-8"
  }, state === null || state === void 0 ? void 0 : (_state$odometerRanges = state.odometerRanges) === null || _state$odometerRanges === void 0 ? void 0 : _state$odometerRanges.map(function (range, index) {
    return /*#__PURE__*/React.createElement(FlowOption, {
      key: range.name,
      id: "sell-car-odometer-option-".concat(index),
      onClick: function onClick() {
        return handleOdometerSelect(range);
      }
    }, /*#__PURE__*/React.createElement(FlowOptionBody, {
      name: lang == 'ar' ? range.range_ar : range.range
    }));
  }))))));
};
export default CarOdometerScreen;